/** The three access tiers in KodaCare. */
export type AppPlan = 'free' | 'vital' | 'lifetime';

/** Numeric rank — higher = more access. */
export const PLAN_HIERARCHY: Record<AppPlan, number> = {
  free: 0,
  vital: 1,
  lifetime: 2,
};

/**
 * Maps each feature key to the minimum plan required to access it.
 * 'vital'    → included in Vital and Lifetime (and trial)
 * 'lifetime' → included in Lifetime only (and trial)
 */
export const FEATURE_PLAN_MAP = {
  /** Extra Lifetime trend charts + customise layout */
  customTrends: 'lifetime',
  /** Document Vault */
  vault: 'vital',
  /** Monthly curated kidney tech & community newsletter */
  digest: 'lifetime',
} as const;

export type FeatureKey = keyof typeof FEATURE_PLAN_MAP;

/** Returns true when `userPlan` meets or exceeds `required`. */
export function planMeets(userPlan: AppPlan, required: AppPlan): boolean {
  return PLAN_HIERARCHY[userPlan] >= PLAN_HIERARCHY[required];
}
